import request from '@/utils/request'
// 企业账户信息
export function getAccountInfo() {
  return request({
    url: '/api/company/',
    method: 'get'
  })
}
// 修改企业账户信息
export function putUpdateCompanyInfo(data) {
  return request({
    url: '/api/company/info/',
    method: 'put',
    data
  })
}
// 企业分组信息
export function getCompanyGroup() {
  return request({
    url: '/api/company/group/',
    method: 'get'
  })
}
// 新建企业分组信息
export function postAddCompanyGroup(data) {
  return request({
    url: '/api/company/group/',
    method: 'post',
    data
  })
}
// 修改企业分组信息
export function putCompanyGroup({ GroupName, id }) {
  return request({
    url: `/api/company/group/${id}/`,
    method: 'put',
    data: {
      GroupName
    }
  })
}
// 删除企业分组信息
export function deleteCompanyGroup(id) {
  return request({
    url: `/api/company/group/${id}/`,
    method: 'delete'
  })
}
// 企业用户列表
export function getCompanyUser(params) {
  return request({
    url: '/api/company/user/',
    method: 'get',
    params
  })
}
// 企业用户新建分组和角色列表
export function getCompanyUserExtra() {
  return request({
    url: '/api/company/user/extra/',
    method: 'get'
  })
}
// 新建企业用户信息
export function postAddCompanyUser(data) {
  return request({
    url: '/api/company/user/',
    method: 'post',
    data
  })
}
// 重置密码
export function postResetPasswords({ id, new_password, confirm_password }) {
  return request({
    url: `/api/company/user/${id}/password/`,
    method: 'post',
    data: {
      new_password,
      confirm_password
    }
  })
}
// 企业用户信息详情
export function getCompanyUserInfo(id) {
  return request({
    url: `/api/company/user/${id}/info/`,
    method: 'get'
  })
}
// 修改企业用户信息
export function putCompanyUser({ id, first_name, gender, Group_id, Role_id, customize_infos }) {
  return request({
    url: `/api/company/user/${id}/`,
    method: 'put',
    data: {
      first_name,
      gender,
      Group_id,
      Role_id,
      customize_infos
    }
  })
}
// 企业角色权限
export function getCompanyRole(params) {
  return request({
    url: '/api/company/role/',
    method: 'get',
    params
  })
}
// 删除企业角色权限
export function deleteCompanyRole(id) {
  return request({
    url: `/api/company/role/${id}/`,
    method: 'delete'
  })
}
// 企业角色权限详情
export function getCompanyRoleInfo(id) {
  return request({
    url: `/api/company/role/${id}/info/`,
    method: 'get'
  })
}
// 修改企业角色权限
export function putCompanyRole({ id, Name, Description, ProductIds, ApiPermissions, DataPermissionType, old }) {
  return request({
    url: `/api/company/role/${id}/`,
    method: 'put',
    data: { Name, Description, ProductIds, ApiPermissions, DataPermissionType, old }
  })
}
// 新建企业角色权限
export function postAddCompanyRole(data) {
  return request({
    url: '/api/company/role/',
    method: 'post',
    data
  })
}
//  role权限列表
export function getCompanyRolePermissions() {
  return request({
    url: '/api/company/role/permissions',
    method: 'get'
  })
}
// 用户账户操作:启用
export function postCompanyUserEnadle({ id }) {
  return request({
    url: `/api/company/user/${id}/enable/`,
    method: 'post'
  })
}

// 用户账户操作:停用
export function postCompanyUserDisable({ id }) {
  return request({
    url: `/api/company/user/${id}/disable/`,
    method: 'post'
  })
}

// 埋点接口
export function setBuryPoint(data) {
  return request({
    url: `/api/bury_point/`,
    method: 'post',
    data
  })
}

export function getCompanyList() {
  return request({
    url: '/api/company/',
    method: 'get'
  })
}

export function setTimezone(id, data) {
  return request({
    url: `/api/company/${id}/region/`,
    method: 'post',
    data
  })
}
export function getRoleList() {
  return request({
    url: `/api/company/iams_role/permission/`,
    method: 'get'
  })
}
export function addIamsRole(data) {
  return request({
    url: `/api/company/iams_role/`,
    method: 'post',
    data
  })
}
export function infoIamsRole(params) {
  return request({
    url: `/api/company/iams_role/info/`,
    method: 'get',
    params
  })
}
export function editIamsRole(data) {
  return request({
    url: `/api/company/iams_role/edit/`,
    method: 'post',
    data
  })
}
export function delIamsRole(params) {
  return request({
    url: `/api/company/iams_role/delete/`,
    method: 'delete',
    params
  })
}
export function sendCode(data) {
  return request({
    url: `/api/hubspot/auth/`,
    method: 'post',
    data
  })
}
export function delAuth(params) {
  return request({
    url: `/api/hubspot/auth/delete_bind/`,
    method: 'delete',
    params
  })
}
export function checkAuth(params) {
  return request({
    url: `/api/hubspot/auth/status/`,
    method: 'get',
    params
  })
}

export function getSecurityInfo(params) {
  return request({
    url: `/api/company/account_security/info/`,
    method: 'get',
    params
  })
}

export function setSecurityInfo(data) {
  return request({
    url: `/api/company/account_security/save/`,
    method: 'post',
    data
  })
}

export function setSliding() {
  return request({
    url: `/api/bury_point/sliding/`,
    method: 'post'
  })
}

export function setUnlock(id) {
  return request({
    url: `/api/company/user/${id}/unlock/`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/Account.js